import React, {useEffect} from "react";
import {Script} from "gatsby";
import PropTypes from "prop-types";

/**
 *
 * @param publicApiKey REQUIRED eway public API key
 * @param amount Amount to be paid (in cents)
 * @param currency e.g. "AUD"
 * @param label
 * @param invoiceDescription
 * @param buttonColor
 * @param invoiceRef
 * @return {JSX.Element}
 * @constructor
 */
export function PayNowButton({publicApiKey, label, amount, currency, invoiceDescription, invoiceRef, buttonColor}) {
  // avoid react minified error by loading classname on component mount
  const [isLoaded, setIsLoaded] = React.useState(false)
  useEffect(() => setIsLoaded(true), [])

  return (<>
    <Script src="https://secure.ewaypayments.com/scripts/eCrypt.min.js" defer />
    {/* eway script searches for script element with "eway-paynow-buttons" class */}
    <script className={isLoaded ? "eway-paynow-button" : "not-loaded"}
      data-label={label}
      data-buttoncolor={buttonColor}
      data-publicapikey={publicApiKey}
      data-amount={amount}
      data-currency={currency}
      data-invoicedescription={invoiceDescription}
      data-invoiceref={invoiceRef}
      data-allowedit="true" />
  </>)
}

PayNowButton.defaultProps = {
  amount: "10000",
  currency: "AUD",
  invoiceDescription: "Application Fee",
  buttonColor: "#023e88",
}

PayNowButton.propTypes = {
  publicApiKey: PropTypes.string.isRequired,
  label: PropTypes.string,
  amount: PropTypes.string,
  currency: PropTypes.string,
  invoiceDescription: PropTypes.string,
  invoiceRef: PropTypes.string,
  buttonColor: PropTypes.string
}
